<template>
  <div class="text-center p-8">
    <h5 class="text-xl mb-4">
      SEA Form Required
    </h5>
    <h5 class="text-lg mb-4">
      You must sign the Study Experience Agreement (SEA) form before accessing the Housing platform.
    </h5>
    <p class="mb-4">
      Please complete the SEA form to continue with your housing application.
    </p>
    <p class="mt-4 text-sm text-gray-600">
      If you have already signed the SEA form, please wait a few minutes and refresh this page.
      If the issue persists, contact the Housing department:
      <a
        href="mailto:housing@digipen.edu"
        class="text-blue-600 hover:text-blue-800"
      >
        housing@digipen.edu
      </a>
    </p>
  </div>
</template>
